import PropTypes from 'prop-types';
import React, { forwardRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
  Chip,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
} from '@mui/material';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useToggleLeftDrawer } from '../../../../redux/toggleLeftDrawer';
import * as TablerIcons from '@tabler/icons';

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

const NavItem = ({ item, level }) => {
  const currentPath = window.location.pathname;
  const theme = useTheme();
  const customization = useSelector(state => state.common.customization);
  const matchesSM = useMediaQuery(theme.breakpoints.down('lg'));
  const { toggleLeftDrawer } = useToggleLeftDrawer();

  const Icon = TablerIcons[item.icon] || null;
  const itemIcon = Icon ? (
    <Icon stroke={1.5} size="1.3rem" style={{ transform: item.flip ? 'scaleX(-1)' : '' }} />
  ) : (
    <FiberManualRecordIcon
      sx={{
        width: 6, //customization.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6,
        height: 6, //customization.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6
      }}
      fontSize={level > 0 ? 'inherit' : 'medium'}
    />
  );

  let itemTarget = '_top';
  if (item.target) {
    itemTarget = '_blank';
  }

  let listItemProps = {
    component: forwardRef((props, ref) => (
      <Link ref={ref} {...props} to={item.url} target={itemTarget} />
    )),
  };
  if (item?.external) {
    listItemProps = { component: 'a', href: item.url, target: itemTarget };
  }

  const itemHandler = id => {
    if (item.url === '/referrals/send-fax') {
      toggleLeftDrawer(true);
      return;
    }

    if (matchesSM) {
      console.log('toggleLeftDrawer', false);
      toggleLeftDrawer(false);
    } else {
      console.log('toggleLeftDrawer', true);
      toggleLeftDrawer(true);
    }
  };

  // active menu item on page load
  useEffect(() => {
    const currentIndex = document.location.pathname
      .toString()
      .split('/')
      .findIndex(id => id === item.id);
    if (currentIndex > -1) {
      console.log('toggleLeftDrawer', true);
      toggleLeftDrawer(true);
      //dispatch({ type: MENU_OPEN, id: item.id });
    }
    // eslint-disable-next-line
  }, []);

  return (
    <ListItemButton
      {...listItemProps}
      disabled={item.disabled}
      sx={{
        borderRadius: `${customization.borderRadius}px`,
        mb: 0.5,
        alignItems: 'flex-start',
        backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
        py: level > 1 ? 1 : 1.25,
        pl: `${level * 24}px`,
        pointerEvents: item.url === currentPath ? 'none' : 'auto'
      }}
      color="primary"
      selected={item.url === currentPath}
      onClick={() => item.url !== currentPath ? itemHandler(item.id) : null}
    >
      <ListItemIcon sx={{ my: 'auto', minWidth: !item?.icon ? 18 : 36 }}>{itemIcon}</ListItemIcon>
      <ListItemText
        primary={
          <Typography
            variant={customization.isOpen.findIndex(id => id === item.id) > -1 ? 'h5' : 'body1'}
            color="inherit"
          >
            {item.title}
          </Typography>
        }
        secondary={
          item.caption && (
            <Typography
              variant="caption"
              sx={{ ...theme.typography.subMenuCaption }}
              display="block"
              gutterBottom
            >
              {item.caption}
            </Typography>
          )
        }
      />
      {item.chip && (
        <Chip
          color={item.chip.color}
          variant={item.chip.variant}
          size={item.chip.size}
          label={item.chip.label}
          avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
        />
      )}
    </ListItemButton>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number,
};

export default NavItem;
